import React,{useState,useEffect} from 'react'
import {Table} from "reactstrap";
import {totalDepositList} from 'network/ApiAxiosTickets'


function MoneySellers() {
    const [deposits, setDeposits] = useState({});
    useEffect(() => {
        getTotalDepositList()
    }, []);

    const getTotalDepositList =async()=>{
        const {data} = await totalDepositList()
        if(data.success){
            console.log(data)
            setDeposits(data)
        }
    }
  return (
    <Table className='text-white'>
        <thead>
            <tr>
                <th>
                    Seller
                </th>
                <th>
                    Total
                </th>
            </tr>
        </thead>
        <tbody>
        {deposits.resultFinal && Object.entries(deposits.resultFinal.sellerName).map((row)=>{
            return <tr key={row[0]}><th scope="col">{row[0]}</th><th scope="col">{row[1]} €</th></tr>
        })}
        {deposits.resultFinal && <tr><th scope="col"></th><th scope="col">{deposits.resultFinal.total} €</th></tr>}
        </tbody>
    </Table>
  )
}

export default MoneySellers